import { ComponentClass } from 'react';
import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
import { SxSLayerViewProps } from './components/SxSLayerView';
import { SxSViewProps } from './components/SxSView';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "SxS" */ './lazyIndex'));

export const lazyGetSxSViewStateFromElement = new LazyImport(
    lazyModule,
    m => m.getSxSViewStateFromElement
);

// Delayed Loaded Components
export const SxSLayerView = createLazyComponent(lazyModule, m => m.SxSLayerView);
export const SxSView = createLazyComponent(lazyModule, m => m.SxSView);

export { ComponentClass, SxSLayerViewProps, SxSViewProps };
